/* global require */

'use strict';

require('../css/ui-popup.css');

var directives = require('./directives');

directives.createPopup('popup', {
    template: '<div class="ui-popup"><div ng-transclude></div></div>'
});


//////////////////
// WEBPACK FOOTER
// ./src/directives/popup.js
// module id = 13
// module chunks = 0